import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  JourneyProgressStatus,
  JourneyServiceType,
} from '@modules/vehicle/models/protobuf/Journey';

export interface VehicleState {
  journeyGid?: string;
  journeyServiceType?: JourneyServiceType;
  journeyStartTime?: number;
  lineName?: string;
  destination?: string;
  via?: string;
  destination2?: string;
  isStopPressed?: boolean;
  stops?: string[];
  journeyProgressJourneyGid?: string;
  indexInJourney?: number;
  journeyProgressStatus?: JourneyProgressStatus;
  expires?: number;
  type?: string;
  regNo?: string;
  vehicleNo?: string;
  xid?: string;
  operator?: string;
}

const initialState: VehicleState = {};

const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    journeyChanged(
      state,
      action: PayloadAction<{
        gid: string | undefined;
        serviceType: JourneyServiceType | undefined;
        journeyStartTime: number | undefined;
      }>,
    ) {
      state.journeyGid = action.payload.gid ? action.payload.gid : undefined;
      state.journeyServiceType = action.payload.serviceType;
      state.journeyStartTime =
        action.payload.journeyStartTime !== 0
          ? action.payload.journeyStartTime
          : undefined;
    },
    lineNameChanged(state, action: PayloadAction<string | undefined>) {
      state.lineName = action.payload ? action.payload : undefined;
    },
    destinationChanged(
      state,
      action: PayloadAction<{
        destination: string | undefined;
        via?: string | undefined;
        destination2?: string | undefined;
      }>,
    ) {
      state.destination = action.payload.destination;
      state.via = action.payload.via;
      state.destination2 = action.payload.destination2;
    },
    isStopPressedChanged(state, action: PayloadAction<boolean | undefined>) {
      state.isStopPressed = action.payload;
    },
    stopsChanged(state, action: PayloadAction<string[] | undefined>) {
      state.stops = action.payload;
    },
    journeyProgressChanged(
      state,
      action: PayloadAction<{
        gid: string | undefined;
        indexInJourney: number | undefined;
        status: JourneyProgressStatus | undefined;
      }>,
    ) {
      state.journeyProgressJourneyGid = action.payload.gid;
      state.indexInJourney = action.payload.indexInJourney;
      state.journeyProgressStatus = action.payload.status;
    },
    expiresChanged(state, action: PayloadAction<number | undefined>) {
      state.expires = action.payload;
    },
    typeChanged(state, action: PayloadAction<string>) {
      state.type = action.payload;
    },
    regNoChanged(state, action: PayloadAction<string>) {
      state.regNo = action.payload;
    },
    vehicleNoChanged(state, action: PayloadAction<string>) {
      state.vehicleNo = action.payload;
    },
    xidChanged(state, action: PayloadAction<string>) {
      state.xid = action.payload;
    },
    operatorChanged(state, action: PayloadAction<string>) {
      state.operator = action.payload;
    },
  },
});

export const {
  journeyChanged,
  lineNameChanged,
  destinationChanged,
  isStopPressedChanged,
  stopsChanged,
  journeyProgressChanged,
  expiresChanged,
  typeChanged,
  regNoChanged,
  vehicleNoChanged,
  xidChanged,
  operatorChanged,
} = vehicleSlice.actions;
export default vehicleSlice.reducer;
